module.exports = __webpack_public_path__ + "img/gb-sct.4c2c379f.svg";